import React,{useState} from 'react';
import Carousel, { consts } from 'react-elastic-carousel'
import Item from './Item';
import CourseItem from './CourseItem';
import '../css/Courses.css';
function CoursesBox() {
    const breakPoints = [
        { width: 1, itemsToShow: 1 },
        { width: 550, itemsToShow: 2, itemsToScroll: 2 },
        { width: 768, itemsToShow: 3 },

    ];
    function myArrow({ type, onClick, isEdge }) {
        const pointer = type === consts.PREV ? 'back' : 'forward'
        const btn = <ion-icon name={`chevron-${pointer}-circle`} style={{ color: "#FF7043", fontSize: "35px" }} ></ion-icon>
        return (

            <button style={{ border: "none", background: "none",position:"absolute",top:"45%",zIndex:"2" }} className={type===consts.PREV?"start-0":"end-0"} onClick={onClick} disabled={isEdge}>
                {btn}
            </button>
        )
    }
    
    function renderPagination({ pages, activePage, onClick }) {
        return (
            <div className="d-flex">
              {pages.map(page => {
                const isActivePage = activePage === page
                return (
                  <span
                    key={page}
                    onClick={() => 
                    onClick(page)
                    } style={{background:`${isActivePage?" #FF7043":"#455E5B"}`,width:"20px",height:"20px",borderRadius:"5px",cursor:"pointer"}}
                    active={isActivePage} className='mx-2'> </span>
                )
              })}
            </div>
          )
      }
const [courses, setcourses] = useState([1,2,3,4,5,6,7,8,9,10]);

    return (
        <>
        <section className='courses-container position-relative '>
<div className="pt-5">
            <h1 className='text-center white-text letter-dis-1'>Popular Courses we offer</h1>
            <h5 className='text-center text' style={{color:"#dddddd"}}>There is a moment in the life of any aspiring.</h5>
</div>

            <Carousel
                itemsToShow={3}
                itemsToScroll={1}
                breakPoints={breakPoints}
                easing="cubic-bezier(.13,.79,.7,.1)"
                tiltEasing="cubic-bezier(0.110, 1, 1.000, 0.210)"
                transitionMs={800}
                className='p-2 container position-relative'
                renderArrow={myArrow}
                renderPagination={renderPagination}
                >
                {courses.map((item)=>{
                    return <Item key={item}>
                    <CourseItem title={item} />
                </Item>
                })}
            </Carousel>
            </section>

        </>
    )
}

export default CoursesBox;
